import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-annule-transf',
  templateUrl: './annule-transf.component.html',
  styleUrls: ['./annule-transf.component.scss']
})
export class AnnuleTransfComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
